// File: src/utils/scheduleUtils.js
// Shared schedule display utilities (Issue #83)
// Used by TaskScheduleTab, UserSchedulerDetailDialog, SchedulerUsersTable

/**
 * Derive schedule status from a schedule object.
 * Mirrors backend deriveScheduleStatus() in ScheduleDefinition.js.
 *
 * @param {object} schedule - Schedule object
 * @returns {'active'|'paused'|'admin_paused'|'error'|'disabled'}
 */
export function deriveScheduleStatus(schedule) {
    if (schedule.config?.managedBy === 'reconciler_admin_paused') return 'admin_paused';
    if ((schedule.consecutiveFailures || 0) >= 5) return 'error';
    if (schedule.paused) return 'paused';
    if (schedule.enabled) return 'active';
    return 'disabled';
}

/**
 * Format a past timestamp as relative time.
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} Formatted string
 */
export function formatRelativeTime(timestamp) {
    if (!timestamp) return '-';
    const diff = Date.now() - timestamp;
    if (diff < 60000) return 'just now';
    if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
    return new Date(timestamp).toLocaleDateString();
}

/**
 * Format a future timestamp as relative time.
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} Formatted string
 */
export function formatFutureTime(timestamp) {
    if (!timestamp) return '-';
    const diff = timestamp - Date.now();
    if (diff < 0) return 'overdue';
    if (diff < 60000) return 'soon';
    if (diff < 3600000) return `in ${Math.floor(diff / 60000)}m`;
    if (diff < 86400000) return `in ${Math.floor(diff / 3600000)}h`;
    return new Date(timestamp).toLocaleDateString();
}
